
import React, { Component } from "react";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Drawer } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../_metronic";
import Pagination from "react-js-pagination";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { translations } from '../../../translate.js';
import EFAWATEERcomCommissionForm from "./forms/eFAWATEERcomCommissionForm";
let Strings = localStorage.getItem('LANG') == 1 ? translations.Ar : translations.En;



class eFAWTEERcomCommission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 0,
            limit: 25,
            activePage: 1,
            dataCount: 0,
            efawatercomTypeData: [],
            efawatercomAPI: [],
            openleftModal: false,
            searchKey: '',
        }
    }

    componentDidMount() {
        this.getEfawatercomType();

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (event.target.className != undefined) {
            if (!event.target.classList.contains('actionDropdownList')) {
                this.setState({
                    openHeader: ''
                })
            }
        }
    }

    getEfawatercomType = () => {

        fetch(window.API_PERM_USER, {
            method: 'POST',
            body: JSON.stringify({
                'type': 'getEfwatercomNewApiPercentege',
                'lang': localStorage.getItem('LANG'),
                'userId': localStorage.getItem('USER_ID'),
                'token': localStorage.getItem('USER_TOKEN'),
                "page": this.state.activePage,
                "limit": this.state.limit,

            }),
            headers: {
                'Accept': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(data => {
            if (data !== "Nothing found") {
                if (data['logout'] == 1) {
                    localStorage.setItem('USER_ID', '');
                    localStorage.setItem('USER_TOKEN', '');
                    window.location.href = "/logout";
                } else {
                    console.log(data);
                    this.setState({
                        efawatercomTypeData: data['data'],
                        loading: 1,
                        dataCount: parseInt(data['count'])
                    })
                }
            }
        })
    }
    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, function () {
            this.getEfawatercomType();
        });
    }


    openHeaderMenu = (event, id) => {
        event.preventDefault();
        if (event.target.classList[1] != undefined && event.target.classList[1] == "menu-dots-vertical" && id != undefined) {
            var val = ''
            if (this.state.openHeader == id) {
                val = ''
            } else if (id != undefined) {
                val = id
            }
            this.setState({
                openHeader: val
            })
        } else if (id == undefined && event.target.classList[1] != "menu-dots-vertical") {
            this.setState({
                openHeader: ''
            })
        }
    }

    openSidebarModal = (event, type, data, viewMode) => {
        event.preventDefault();
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.setState({
            propsData: data,
            actionType: type,
            viewMode: viewMode,
            openleftModal: true
        })
    }
    handleCloseSideBar = () => {
        this.setState({ openleftModal: false, propsData: [], actionType: '', viewMode: '' })
    }

    handleFormAction = () => {
        this.setState({
            propsData: [],
            actionType: '',
            openleftModal: false,
            viewMode: ''
        }, function () {
            this.getEfawatercomType()

        })
    }
    rowData = (data, type) => {
        return (
            <Col lg={2} md={2} sm={6} xs={6} className="overflow-text-length" title={data}>{data}</Col>
        )
    }
    displayData = () => {
        var efawatercomTypeInfo = ''
        if (this.state.loading == 1 && this.state.efawatercomTypeData.length > 0) {
            efawatercomTypeInfo = this.state.efawatercomTypeData.map((rowData, index) => {
                return (
                    <Row key={index} className='table-body-row'>
                        {this.rowData(rowData['apiCommission'])}
                        {this.rowData(rowData['profitPercentege'])}
                        {this.rowData(rowData['distCommission'])}
                        {this.rowData(rowData['PosCommission'])}


                        <Col lg={3} md={3} sm={6} xs={6} className={'action-icon-view actionDropdownList actionDropdownListPadding-0 text-md-right'}  >
                            <Dropdown isOpen={(this.state.openHeader == rowData['id'] ? true : false)} className="font-size-13 actionDropdownList actionDropdownListPadding-0 orderlistActionlist" >
                                <DropdownToggle tag="a" className="nav-link pt-0 actionDropdownList  actionDropdownListPadding-0" caret  >
                                    <MoreVertIcon className='menu-dots-vertical' onClick={(event) => this.openHeaderMenu(event, rowData['id'])} />
                                </DropdownToggle>
                                <DropdownMenu className="font-size-13 modal-left-0 actionDropdownList" >
                                    <div className="actionDropdownList" style={{ maxHeight: '250px', overflowY: 'scroll' }}>
                                        <DropdownItem className='actionDropdownList' onClick={(event) => this.openSidebarModal(event, 'edit', rowData)}>{Strings['Edit']}</DropdownItem>
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                    </Row>
                )
            })
        }
        return efawatercomTypeInfo;
    }


    render() {

        return (
            <div>
                <Row>
                    <Col md={12} className='main-color-1 inv-class-view-title mb-4'>
                        <div>{Strings['E-fawatercom Commission']}</div>
                        <hr className='inv-hr-view-2' />
                    </Col>
                </Row>


                {/* {this.state.efawatercomAPI.length > this.state.dataCount &&
                    <Row className='page-filter-view'>

                        <Col md={12} lg={12} className='text-right'>
                            <button className="btn gradient-button-view gradient-button gradient-button-font-12 ml-1 mt-2 mt-md-0" onClick={(event) => this.openSidebarModal(event, 'add', '')}>
                                {Strings['Add']} {Strings['Commission']}
                            </button>
                        </Col>
                    </Row>
                } */}
                {this.state.loading == 1 && this.state.efawatercomTypeData.length <= 0 &&
                    <Row>
                        <div className='inv-cards-view pb-5 width-100'>
                            <div className='text-center' style={{ marginTop: "15%", marginBottom: "15%" }}>
                                <img alt="Logo" src={toAbsoluteUrl("/media/ezpay/EZPAY_LOGO_GRAY" + window.MAIN_IMAGE + ".png")} className='img-fluid no-data-img' />
                                <div className='no-data-text'>{Strings["There is no data to display"]}</div>
                            </div>
                        </div>
                    </Row>
                }

                {this.state.loading == 1 && this.state.efawatercomTypeData.length > 0 &&
                    <Row className='inv-cards-view'>

                        <Col>
                            <Row className='table-header-row'>
                                <Col lg={2} md={2} sm={6} xs={6} className="overflow-text-length" title={Strings['API Commission']}>{Strings['API Commission']}</Col>
                                <Col lg={2} md={3} sm={6} xs={6} className="overflow-text-length" title={Strings['Profit Percentage']}>{Strings['Profit Percentage']}</Col>
                                <Col lg={2} md={3} sm={6} xs={6} className="overflow-text-length" title={Strings['Distributor Commission']}>{Strings['Distributor Commission']}</Col>
                                <Col lg={2} md={2} sm={6} xs={6} className="overflow-text-length" title={Strings['POS Commission']}>{Strings['POS Commission']}</Col>

                                <Col lg={3} md={2} sm={6} xs={6} className="overflow-text-length text-md-right" title={Strings['Action']}> {Strings['Action']}</Col>
                            </Row>
                            {this.displayData()}
                        </Col>
                        {/* <Col md={12}>
                            <Row className='pagenation-view mt-3 mb-4'>
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={this.state.limit}
                                    totalItemsCount={this.state.dataCount}
                                    pageRangeDisplayed={4}
                                    onChange={this.handlePageChange}
                                    prevPageText={<i className={localStorage.getItem('LANG') == 1 ? 'flaticon2-next' : 'flaticon2-back'}></i>}
                                    nextPageText={<i className={localStorage.getItem('LANG') == 1 ? 'flaticon2-back' : 'flaticon2-next'}></i>}
                                    hideFirstLastPages
                                    innerClass={'pagination  pagination-rounded justify-content-end pagenation-view my-2'}
                                    itemClass={'page-item'}
                                    linkClass={'page-link'}
                                />
                            </Row>
                        </Col> */}

                    </Row >
                }
                {
                    this.state.loading == 0 &&
                    <Row>
                        <Col md={12} style={{ marginTop: "15%" }} className='text-center'>
                            <div className='card-body'>
                                <div className='spinner-grow text-dark m-2 main-color-1' role='status'></div>
                                <div className='spinner-grow text-dark m-2 main-color-2' role='status'></div>
                                <div className='spinner-grow text-dark m-2 main-color-1' role='status'></div>
                                <div className='spinner-grow text-dark m-2 main-color-2' role='status'></div>
                                <div className='spinner-grow text-dark m-2 main-color-1' role='status'></div>
                                <div className='spinner-grow text-dark m-2 main-color-2' role='status'></div>
                            </div>
                        </Col>
                    </Row>
                }
                <Drawer anchor={localStorage.getItem('LANG') == 1 ? 'left' : 'right'} open={this.state.openleftModal} className='sidebar-modal-view'>


                    {this.state.actionType == 'edit' &&
                        <EFAWATEERcomCommissionForm
                            handleCloseSideBar={this.handleCloseSideBar}
                            data={this.state.efawatercomTypeData}
                            handleFormAction={this.handleFormAction}
                        />
                    }

                </Drawer>

            </div>

        )
    }
}
export default eFAWTEERcomCommission;